import * as React from 'react';

function SvgRefresh(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.525 2.217a.742.742 0 10-1.05 1.05l2.336 2.336A27.214 27.214 0 0012 5.553a8.223 8.223 0 108.224 8.223.742.742 0 10-1.485 0A6.739 6.739 0 1112 7.037c.968 0 1.624.032 2.06.076L11.476 9.7a.742.742 0 101.05 1.05l3.74-3.741a.742.742 0 000-1.05l-3.74-3.74z", clipRule: "evenodd" })));
}

export default SvgRefresh;
